var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$bem()},[_c('div',{class:_vm.$bem('inner')},[_c('e-text',{class:_vm.$bem('label'),attrs:{"tag":"h5"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }